export default __webpack_public_path__ + "static/dog-walking-c7ecc637b63b5c2a1ef7ad9f4e97f119.png";